import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=863324f0&scoped=true&scrollable=true&"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js&"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountForm.vue?vue&type=style&index=0&id=863324f0&lang=sass&scoped=true&"
import style1 from "./CreateAccountForm.vue?vue&type=style&index=1&id=863324f0&scoped=true&lang=css&"
import style2 from "./CreateAccountForm.vue?vue&type=style&index=2&id=863324f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863324f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VCol,VForm,VRow,VSpacer,VTextField,VTooltip})
